import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Typography, Chip } from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Iconify from "../common/Iconify";
import Capsule from "../common/Capsule";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { Notification } from "../common/Notification";
import { hasWritePermission } from "../common/PermissionUtility";
import ModalPopUp from "../common/TransForm/ModalPopUp"; // Import ModalPopUp component

export default function ScheduleReportList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Local states
  const [scheduleReports, setScheduleReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
  
  // Delete confirmation modal states
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [itemToDelete, setItemToDelete] = useState(null);
  
  console.log(scheduleReports, "scheduleReports123")
  
  // Permission check
  const canWriteReports = hasWritePermission('schedulerreport');
  
  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };
  
  // Format emails helper function
  const formatEmails = (emailArray) => {
    if (!emailArray || emailArray.length === 0) return 'No recipients';
    if (emailArray.length === 1) return emailArray[0];
    return `${emailArray[0]} (+${emailArray.length - 1} more)`;
  };

  // Table columns for display
  const reportTableColumns = (params) => [
    {
      key: "id",
      label: "Report ID",
      align: "left",
      fontSize: '15px',
      valueRenderer: (data) => {
        return data["serial_no"] || data["id"];
      },
    },
     { 
      key: "report_headline", 
      label: "Report Headline", 
      align: "left", 
      fontSize: "15px",
      valueRenderer: (data) => {
        return data.report_headline || 'Untitled Report';
      }
    },
    { 
      key: "report_type", 
      label: "Report Type", 
      align: "left", 
      fontSize: "15px",
      valueRenderer: (data) => {
        return formatEmails(data.report_type) || 'N/A';
      }
    },
    { 
      key: "iteration_timing", 
      label: "Frequency", 
      align: "center",
      fontSize: "14px",
      valueRenderer: (data) => {
        const timing = data.iteration_timing || 'Not Set';
        let color = '#64748B';
        let bgColor = '#87878714';
        
        if (timing === 'Daily') {
          color = '#219653';
          bgColor = '#21965333';
        } else if (timing === 'Weekly') {
          color = '#F59E0B';
          bgColor = '#F59E0B33';
        } else if (timing === 'Monthly') {
          color = '#3B82F6';
          bgColor = '#3B82F633';
        }
        
        return <Capsule data={timing} bgColor={bgColor} color={color} />;
      }
    },
    { 
      key: "to_email", 
      label: "Recipients", 
      align: "left",
      fontSize: "14px",
      valueRenderer: (data) => {
        return formatEmails(data.to_email);
      }
    },
    { 
      key: "email_count", 
      label: "Email Count", 
      align: "center",
      fontSize: "14px",
      valueRenderer: (data) => {
        return data.email_count || 0;
      }
    },
    { 
      key: "report_time", 
      label: "Report Time", 
      align: "left",
      fontSize: "14px",
      valueRenderer: (data) => {
        return data.report_time ? formatDate(data.report_time) : 'Not scheduled';
      }
    },
    ...(canWriteReports ? [{
      key: "action",
      label: "Action",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box display="flex" gap={1} justifyContent="center">
            <IconButton onClick={() => params.goToEditReport(data)} title="Edit">
              <Iconify icon="eva:edit-outline" size="small" color="#00000" />
            </IconButton>
            <IconButton onClick={() => params.goToDeleteReport(data)} title="Delete">
              <Iconify icon="eva:trash-2-outline" size="small" color="error.main" />
            </IconButton>
          </Box>
        );
      },
    }] : [{
      key: "action",
      label: "Action",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box>
            <IconButton onClick={() => params.goToViewReport(data)} title="View">
              <Iconify icon="eva:eye-outline" size="small" color="primary.main" />
            </IconButton>
          </Box>
        );
      },
    }]),
  ];

  // Excel table columns (without React components)
  const reportExcelTableColumns = () => [
    {
      key: "id",
      label: "Report ID",
      align: "left",
      fontSize: '15px',
      valueRenderer: (data) => {
        return data.serial_no || data.id;
      },
    },
    { 
      key: "report_headline", 
      label: "Report Headline", 
      align: "left", 
      fontSize: "15px",
      valueRenderer: (data) => {
        return data.report_headline || 'Untitled Report';
      }
    },
     { 
      key: "report_type", 
      label: "Report Type", 
      align: "left",
      fontSize: "14px",
      valueRenderer: (data) => {
        return Array.isArray(data.report_type) ? data.report_type.join(', ') : 'Untitled Type';
      }
    },
    { 
      key: "iteration_timing", 
      label: "Frequency", 
      align: "center",
      fontSize: "14px",
      valueRenderer: (data) => {
        return data.iteration_timing || 'Not Set';
      }
    },
    { 
      key: "to_email", 
      label: "Recipients", 
      align: "left",
      fontSize: "14px",
      valueRenderer: (data) => {
        return Array.isArray(data.to_email) ? data.to_email.join(', ') : 'No recipients';
      }
    },
    { 
      key: "email_count", 
      label: "Email Count", 
      align: "center",
      fontSize: "14px",
      valueRenderer: (data) => {
        return data.email_count || 0;
      }
    },
    { 
      key: "report_time", 
      label: "Report Time", 
      align: "left",
      fontSize: "14px",
      valueRenderer: (data) => {
        return data.report_time ? formatDate(data.report_time) : 'Not scheduled';
      }
    },
  ];

  // Fetch schedule reports with pagination and sorting
  const getScheduleReports = useCallback(async (page = 1, limit = 10, orderBy = '', order = '') => {
    setScheduleReports([]);
    try {
      if (!loading) {
        setLoading(true);
        
        // Build query parameters
        let queryParams = `page=${page}&limit=${limit}`;
        
        // Add sorting parameters if provided
        if (orderBy && order) {
          queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;
        }
        
        console.log(`${base_url}/api/accounts/admin/scheduler-reports/?${queryParams}`, "ScheduleReportsURL");
        
        const response = await Axios.get(
          `${base_url}/api/accounts/admin/scheduler-reports/?${queryParams}`, 
          Config
        );
        console.log(response, "ScheduleReportsURLresponse")
        if (response?.status === 200) {
          let startIndex = (page - 1) * limit + 1;
          let data = response?.data?.results?.results; // Handle both array and single object responses
          console.log(data, "dataScheduleReports")
          // Add serial numbers
          data = data.map(item => ({
            ...item,
            serial_no: startIndex++
          }));
          console.log(response?.data?.results?.count, "resultsCount")
          setScheduleReports(data);
          setTotalCount(response?.data?.results?.count || data.length);
        }
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching schedule reports:', error);
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
    }
  }, [loading]);

  // Separate function to force refresh the list after operations
  const refreshScheduleReports = async () => {
    try {
      setLoading(true);
      
      // Build query parameters with current pagination and sorting
      let queryParams = `page=${currentPage + 1}&limit=${rowsPerPage}`;
      
      if (sortBy && sortOrder) {
        queryParams += `&sort_by=${sortBy}&order=${sortOrder !== 'desc' ? 'desc' : 'asc'}`;
      }
      
      const response = await Axios.get(
        `${base_url}/api/accounts/admin/scheduler-reports/?${queryParams}`, 
        Config
      );
      
      if (response?.status === 200) {
        let startIndex = currentPage * rowsPerPage + 1;
        let data = response?.data?.results?.results;
        
        // Add serial numbers
        data = data.map(item => ({
          ...item,
          serial_no: startIndex++
        }));
        
        setScheduleReports(data);
        setTotalCount(response?.data?.results?.count || data.length);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error refreshing schedule reports:', error);
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
    }
  };

  // Handle pagination change from TransTable
  const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    getScheduleReports(page + 1, rowsPerPage, sortBy, sortOrder);
  }, [sortBy, sortOrder, getScheduleReports]);

  // Handle sorting change from TransTable
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    setCurrentPage(0);
    getScheduleReports(1, rowsPerPage, orderBy, order);
  }, [rowsPerPage, getScheduleReports]);

  // Navigation functions
  const goToAddReport = () => {
    navigate("new");
  };

  const goToEditReport = (data) => {
    navigate(`edit/${data.id}`, { state: { reportData: data } });
  };

  const goToViewReport = (data) => {
    navigate(`view/${data.id}`, { state: { reportData: data } });
  };

  // Updated delete function to show confirmation popup
  const goToDeleteReport = (data) => {
    setItemToDelete(data);
    setDeleteMessage(`Are you sure you want to delete the report "${data.report_headline || 'Untitled Report'}"?.`);
    setDeleteConfirmOpen(true);
  };

  // Confirm delete function
  const confirmDelete = async () => {
    if (!itemToDelete) return;
    
    try {
      setLoading(true);
      const response = await Axios.delete(
        `${base_url}/api/accounts/admin/scheduler-reports/${itemToDelete.id}`, 
        Config
      );
      
      console.log(response, "deleteResponse");
      
      if (response?.data?.success === true) {
        // Show success message
        setErrorMessage(response?.data?.message || 'Report deleted successfully');
        setNotification(true);
        
        // Close the modal
        setDeleteConfirmOpen(false);
        setItemToDelete(null);
        
        // Refresh the list after successful deletion
        await refreshScheduleReports();
      } else {
        // Handle case where success is not true
        setErrorMessage(response?.data?.message || 'Failed to delete report');
        setNotification(true);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Delete error:', error);
      
      // Check if the error response has a message
      if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Failed to delete report. Please try again.');
      }
      setNotification(true);
      
      RefreshToken(error, setErrorMessage, setNotification);
    }
  };

  // Cancel delete function
  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setItemToDelete(null);
    setDeleteMessage('');
  };
  
  // Excel download functionality
  const [allExcelData, setAllExcelData] = useState([]);

  const getAllReportsForExcel = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(
        `${base_url}/api/dashboard/scheduler-reports/all/`, // Assuming this endpoint exists
        Config
      );
      
      if (response?.status === 200) {
        let data = response?.data?.data || response?.data;
        data = data.map((item, index) => ({
          ...item,
          serial_no: index + 1,
        }));

        setLoading(false);
        return data;
      }
      setLoading(false);
      return [];
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
      return [];
    }
  };

  const handleExcelDownload = async () => {
    try {
      setLoading(true);
      const allReportsData = await getAllReportsForExcel();
      
      if (allReportsData.length > 0) {
        setAllExcelData(allReportsData);
        setTimeout(() => {
          setAllExcelData(allReportsData);
        }, 100);
      } else {
        setAllExcelData(scheduleReports);
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      setAllExcelData(scheduleReports);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    getScheduleReports(1, 10);
  }, []);

  return (
    <>
      <Box>
        <TransTable
          pageTitle="Schedule Reports"
          addBtnTitle={'Add new report +'}
          showSearch={false}
          checkbox={false}
          columns={reportTableColumns({ 
            goToEditReport, 
            goToViewReport, 
            goToDeleteReport 
          })}
          rows={scheduleReports}
          addBtnAction={goToAddReport}
          isLoading={loading}
          excelColumns={reportExcelTableColumns()}
          
          // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          showAddBtn={canWriteReports}
          isExcel={canWriteReports}
          
          // Excel functionality
          customExcelData={allExcelData}
          onExcelDownload={handleExcelDownload}
        />
        
        {/* Notification for success/error messages */}
        <Notification 
          message={errorMessage} 
          setopen={setNotification} 
          type={errorMessage.toLowerCase().includes('success') ? 'success' : 'error'} 
          show={notification} 
        />
      </Box>
      
      {/* Delete Confirmation Modal */}
      <ModalPopUp
        openpopup={deleteConfirmOpen}
        setPopup={setDeleteConfirmOpen}
        title={'Confirm Delete'}
        subTitle={deleteMessage}
        onClick={confirmDelete}
        save={'Yes, Delete'}
        cancel={'Cancel'}
        onCancel={cancelDelete}
      />
    </>
  );
}